import { RADIO_QUEUE_KINDS } from './hitLabRadioTracks';

// Shared existing random selection: choose songs, retaining their queue indexes.
export const getRandomRadioTrackQueueIndex = (queue = [], random = Math.random) => {
  const trackIndexes = [];
  (Array.isArray(queue) ? queue : []).forEach((item, index) => {
    if (item?.kind === RADIO_QUEUE_KINDS.TRACK) trackIndexes.push(index);
  });
  if (!trackIndexes.length) return 0;
  const rawRandom = typeof random === 'function' ? Number(random()) : 0;
  const safeRandom = Number.isFinite(rawRandom)
    ? Math.min(Math.max(rawRandom, 0), 0.999999)
    : 0;
  return trackIndexes[Math.floor(safeRandom * trackIndexes.length)];
};

export const getRadioStartupQueueIndex = (queue = [], startTrackId, random = Math.random) => {
  const index = typeof startTrackId === 'string' && startTrackId.length <= 120
    ? (Array.isArray(queue) ? queue : []).findIndex(item =>
      item?.kind === RADIO_QUEUE_KINDS.TRACK && item.id === startTrackId)
    : -1;
  return index >= 0 ? index : getRandomRadioTrackQueueIndex(queue, random);
};
